module.exports = {"StatusCode":200,"Payload":[{}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/updateSiteTypes.json
// module id = LsAm
// module chunks = 0